<template>
    <v-app id="login" class="primary">
        <v-content>
            <v-container fluid fill-height>
                <v-layout align-center justify-center>
                    <v-flex xs12 sm8 md4 lg4>
                        <v-card class="elevation-1 pa-3">
                            <v-card-text>
                                    <div class="layout column align-center">
                                        <img src="/static/m.png" alt="Vue Material Admin" width="120" height="120">
                                        <h1 class="flex my-4 primary--text">Wasilni Operation Dashboard</h1>
                                        <v-layout row wrap>
                                            <v-flex xs6>
                                                <img v-if="!!qrCode" :src="qrCode" alt="QR Code"/>
                                            </v-flex>
                                            <v-flex xs6>
                                                <v-form>
                                                    <v-text-field :error="error" append-icon="person" name="login" label="Login"
                                                                  v-on:keyup.enter="login"
                                                                  type="text"
                                                                  required=true
                                                                  v-model="model.username"></v-text-field>
                                                    <v-text-field :error="error" append-icon="lock" name="password" label="Password"
                                                                  v-on:keyup.enter="login"
                                                                  id="password"
                                                                  required=true
                                                                  type="password" v-model="model.password"></v-text-field>
                                                    <v-btn block color="primary" @click="login" :loading="loading">Login</v-btn>
                                                </v-form>
                                            </v-flex>
                                        </v-layout>

                                    </div>


                            </v-card-text>

                        </v-card>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-content>
    </v-app>
</template>

<script>
    import QRCode from "qrcode";
    import io from "socket.io-client";
    import axios from "axios";
    import store from "@/store";

    export default {
        title: 'Login',
        data: () => ({
            loading: false,
            error: false,
            model: {
                username: '',
                password: ''
            },
            qrCode: null,
            socket: null
        }),
        mounted() {
            this.axios.get(this.api.ACTIONS.GET_LOGIN_IDENTFIER)
                .then(({data: {data: qrCode}}) => {
                    QRCode.toDataURL(qrCode, {
                        errorCorrection: "high",
                        version: 4
                    })
                        .then(
                            data => {
                                this.qrCode = data;
                                this.socket = io(this.api.SOCKET.GUESTS, {
                                    transportOptions: {
                                        polling: {
                                            extraHeaders: {
                                                authorization: qrCode
                                            }
                                        }
                                    }
                                });
                                this.socket.on("authenticate", async token => {
                                    await this.$store.dispatch('validateToken', token);
                                    // const user = this.$store.state.user;
                                    let next = this.$route.query.next || '/dashboard';
                                    // if (this.airportAgency(user.roles))
                                    //     next = 'airport/create';
                                    window.getApp.$emit('APP_LOGIN_SUCCESS');
                                    await this.$router.push(next);
                                });
                            }
                        )
                })

        },
        methods: {
            async login() {
                this.error = false;
                this.loading = true;
                this.axios.post(this.api.ACTIONS.LOGIN, {...this.model, provider: 'users'})
                    .then(({data}) => {
                        this.$store.commit('LOGIN', data.data);
                        let next = this.$route.query.next || '/dashboard';
                        if (this.airportAgency(data.data.roles)) {
                            next = 'airport/create';
                        }
                        window.getApp.$emit('APP_LOGIN_SUCCESS');
                        this.$router.push(next);
                    })
                    .catch((err) => {
                        console.log(err.message);
                        this.error = true;
                        let response = err.response;
                        if (response) {
                            window.getApp.$emit('SHOW_TOAST', response.data.message, 'red');
                            console.log(response.data);
                        } else {
                            window.getApp.$emit('SHOW_TOAST', 'Check your info', 'red');
                        }
                    })
                    .then(() => this.loading = false);
            }
        }

    };
</script>
<style scoped lang="css">
    #login {
        height: 50%;
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        content: "";
        z-index: 0;
    }
</style>
